import React from "react";
import {
  Container,
  Card,
  Table,
  Button,
  Row,
  Col
} from "react-bootstrap";
import barcode from "../assets/images/barcode.jpeg"

import {
  useLocation,
  useNavigate
} from "react-router-dom";

export default function PaymentPage() {

  const location = useLocation();

  const navigate = useNavigate();

  const booking = location.state;

  if (!booking) {

    return (
      <Container className="py-5 text-center">

        <h3>No Booking Data Found</h3>

        <Button onClick={() => navigate("/")}>
          Go Back
        </Button>

      </Container>
    );
  }

  return (
    <Container className="py-5">
  {/* Payment Button */}
          <div className="text-center mt-4">


<Row>
    <Col md="4"><h2>Pay Now</h2><img src={barcode} alt=""/></Col>
    <Col md="8"><div
  className="text-center p-4 mt-4"
  style={{
    background: "#f8f9fa",
    borderRadius: "10px",
    border: "1px solid #ddd"
  }}
>

  <h4 className="text-success mb-3">
    ✅ Booking Successful
  </h4>

  <p className="mb-3">
    Please complete your payment by scanning the
    QR Code / Barcode.
  </p>

  <p className="fw-bold mb-2">
    After payment kindly send the payment screenshot
    on WhatsApp:
  </p>

  <h5 className="text-primary">
    📱 +91 9455859888
  </h5>

  <a
    href="https://wa.me/919455859888"
    target="_blank"
    rel="noreferrer"
    className="btn btn-success mt-3"
  >
    WhatsApp Now
  </a>

</div></Col>
</Row>
          </div>

      <Card className="shadow border-0">

        <Card.Body>

          {/* Success Message */}
          {/* <Alert variant="success" className="text-center">

            <h4 className="mb-2">
              ✅ Booking Successful
            </h4>

            <p className="mb-0">
              Your turf booking has been submitted successfully.
            </p>

          </Alert> */}

          <h2 className="mb-4 text-center">
            Payment Details
          </h2>

          {/* Customer Info */}
          <h5>Customer Information</h5>

          <Table bordered>

            <tbody>

              <tr>
                <td><strong>Name</strong></td>
                <td>{booking.customer.name}</td>
              </tr>

              <tr>
                <td><strong>Mobile</strong></td>
                <td>{booking.customer.mobile}</td>
              </tr>

              <tr>
                <td><strong>Email</strong></td>
                <td>{booking.customer.email}</td>
              </tr>

            </tbody>

          </Table>

          {/* Slot Details */}
          <h5 className="mt-4">
            Selected Slots
          </h5>

          <Table bordered>

            <thead>

              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Price</th>
              </tr>

            </thead>

            <tbody>

              {booking.selectedSlots.map((slot, index) => (

                <tr key={index}>

                  <td>{slot.date}</td>

                  <td>{slot.time}</td>

                  <td>₹{slot.price}</td>

                </tr>

              ))}

              <tr>

                <td colSpan="2">
                  <strong>Total</strong>
                </td>

                <td>
                  <strong>₹{booking.total}</strong>
                </td>

              </tr>

            </tbody>

          </Table>

        
        </Card.Body>

      </Card>

    </Container>
  );
}